import { rememberedChips, toggleChip } from './clockFilterState';

// The Cycle Clock's stage filter (DWLF-547): any combination of stage chips, none ticked = All. In window
// order: Early + Window open + Confirmed + Late keep every market from its `earliest` edge to its `hardMax`;
// a confirmed setup is only under Confirmed, wherever its window stands.
// In the indicators library's window-stage words, Early window is `earliest` (not its `early`, which is inside the
// window) and Late window is `late`, which the clock shows as its Overdue stage.
export const STAGE_FILTERS = [
  { id: 'early', label: 'Early window', short: 'Early', match: ['early'], title: 'past the shortest gap on record, before the window opens' },
  { id: 'open', label: 'Window open', short: 'Open', match: ['open', 'awaiting'], title: 'window open on the screener or by its dates, no daily confirmation yet' },
  { id: 'confirmed', label: 'Confirmed', short: 'Confirmed', match: ['confirmed'], title: 'daily pivot confirmed on the screener' },
  { id: 'late', label: 'Late window', short: 'Late', match: ['overdue'], title: 'past the window close, before its hard max (shown as Overdue)' },
  { id: 'missed', label: 'Missed', short: 'Missed', match: ['missed'], title: 'past the hard max with no confirmed pivot' },
];

const ORDER = STAGE_FILTERS.map((f) => f.id);

export const matchesStages = (ids, m) => !ids.length || STAGE_FILTERS.some((f) => ids.includes(f.id) && f.match.includes(m.stage.key));

/** Ticks or unticks one chip, keeping the chips' own order. */
export const toggleStage = (ids, id) => toggleChip(ORDER, ids, id);

/** Markets per chip, and `all`, over the markets given (the caller passes those its other filters keep). */
export const stageCounts = (markets) => Object.fromEntries([
  ['all', markets.length],
  ...STAGE_FILTERS.map((f) => [f.id, markets.filter((m) => f.match.includes(m.stage.key)).length]),
]);

const remembered = rememberedChips('cycle-clock-stages', ORDER);
export const readStageFilter = remembered.read;
export const saveStageFilter = remembered.save;
